// extracted by mini-css-extract-plugin
export default {"white":"#fff","notificationRed":"#ff4c68","primaryIcon":"#309df0","Panel":"ben_a big_ea big_ke big_ju big_sn big_wl"};